var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"flex"},[_c('ActionHeader',{staticClass:"w-full"})],1),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"w-full"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }